import React from "react";
import { Divider } from "@chakra-ui/react";

const SeparatorField = () => <Divider />;

export default SeparatorField;
